/** @jsxImportSource @emotion/react */

import {
  CSSRulesResolver,
  useCSSRulesWithTheme,
} from "hooks/useCSSRulesWithTheme";
import { FC } from "react";

const getCSSRules: CSSRulesResolver = ({ colors }) => ({
  inputDivider: {
    display: "inline-block",
    height: 8,
    width: 1,
    background: colors.Grey[300],
  },
});

const InputDivider: FC<{ className?: string }> = ({ className }) => {
  const styles = useCSSRulesWithTheme(getCSSRules);

  return <div css={styles.inputDivider} className={className} />;
};

export default InputDivider;
